var _rect, _rect2, _text, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompetitivePrice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad4",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8B5CF6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#3B82F6",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 50,
    width: 80,
    height: 100,
    rx: 10,
    fill: "url(#grad4)",
    opacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 55,
    width: 70,
    height: 90,
    rx: 8,
    fill: "url(#grad4)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 120,
    fontFamily: "Arial, sans-serif",
    fontSize: 60,
    fontWeight: "bold",
    fill: "white",
    textAnchor: "middle"
  }, "Rp")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10 0 L 15 0 L 15 -20 Q 15 -25 20 -25 Q 25 -25 25 -20 L 25 0 L 40 0 L 40 20 L 10 20 Z",
    fill: "#10B981",
    stroke: "#10B981",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 0,
    width: 5,
    height: 20,
    fill: "#10B981"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitivePrice);
export default __webpack_public_path__ + "static/media/CompetitivePrice.c3b9f6bc4fa27d1bcc79d6d087d136c7.svg";
export { ForwardRef as ReactComponent };